import React, { useEffect, useState, useRef} from 'react';
import Button, {ButtonTheme } from '../../atoms/button/button';
import './LogComponent.scss';
import LogElement from './LogElement';
const Pagination=({page,pages,onPageChange})=>{
  const [pageList,setPageList] =useState([]);
  const [currentPage,setCurrentPage] =useState(1);
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= pages) {
      let t=generatePagination(newPage,pages);
      setPageList(t);
      setCurrentPage(newPage);
      onPageChange(newPage);
    }
  };
  const generatePagination = (currentPage,totalPages) => {
    const delta = 2;
    let pages = [];
    
    for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || 
            (i >= currentPage - delta && i <= currentPage + delta)) {
            pages.push(i);
        } else if (pages[pages.length - 1] !== "...") {
            pages.push("...");
        }
    }
    return pages;
};
useEffect(()=>{
  setPageList(generatePagination(1,pages));
},[pages]);

  return <div className="log-pagination-block content flex items-center space-x-2">
    <ul style={{ display: "flex", listStyle: "none", gap: "10px", padding: 0 }}>
        {
          <li
            key={"prev"}
            className={"log-page px-3 py-1 rounded "+(1===page?"log-page-disabled":"")}
            onClick={() => 1 !== "..." && handlePageChange(currentPage-1)}
          >
              {"<"}
          </li>
        }
        {pageList.map((p, index) => (
          <li
            key={index}
            className={"log-page px-3 py-1 rounded "+(p===page?"log-page-selected":"")}
            onClick={() => p !== "..." && handlePageChange(p)}
          >
            {p}
          </li>
        ))}
        { 
          <li
            key={"next"}
            className={"log-page px-3 py-1 rounded "+(pages===page?"log-page-disabled":"")}
            onClick={() => pages !== "..." && handlePageChange(currentPage+1)}
          >
            {">"}
          </li>
        }
    </ul>
</div>
}
const LogPagination = ({ id,label,refreshPaginationButton,logs,totalLogs,filters,page, pages, pageSize, onPageChange, onRefreshLogs }) => {
    const topElementRef = useRef(null);
    const scrollToTop = () => {
      if (topElementRef.current) {
        topElementRef.current.scrollTo({ top: 0, behavior: "auto" });
      }
    };
    const handleChangePage=(p)=>{
      scrollToTop();
      onPageChange(p);
    }
    useEffect(()=>{
        // console.log("change page to",page,pages,pageSize);
    },[logs,page,pageSize,pages]);
   
    const firstRecord=()=>{
      return page*pageSize-pageSize+1;
    }
    const lastRecord=()=>{
      if(totalLogs>page*pageSize)
        return page*pageSize;
      else{
        return totalLogs;
      }
    }
    const handleRefresh=()=>{
      onRefreshLogs();
    }
    return (
      <>
        {refreshPaginationButton && <div className="log-button-center">
          <Button
              id={`refresh`}
              type={'button'}
              onClick={() => handleRefresh()}
              theme={ButtonTheme.PRIMARY}
            >
              Refresh logs
          </Button>
        </div>}
        {totalLogs==0 && <div className="logComponent-log">------- no results --------</div>}
        {logs && logs.length>0 && <div className='filter-main'>
            <div className='filterinfo'>{firstRecord()}-{lastRecord()} {logs && logs.length} {filters && filters.length>0?"filtered":"showed"} of {(totalLogs)} {(filters && filters.lenght>0?"filtered logs":"total logs")}</div>
        </div>}
        <div className="">
            <div ref={topElementRef} className="logComponent-log">
              {logs && logs.length>0 && logs.map((el,index)=>{
                return(
                  <div key={index}>
                    <LogElement data={JSON.parse(el)}/>
                  </div>
                );
              })}
              </div>
              {totalLogs>0 && <Pagination page={page} pages={pages} onPageChange={handleChangePage} onRefresh={handleRefresh}/>}
        </div>
      </>
    );
  };
  export default LogPagination;
